<template>
  <v-dialog v-model="dialog_ativo" persistent fullscreen transition="dialog-bottom-transition">
    <v-card>
      <div id="titulo-dialog">
        <v-btn icon dark class="mr-4" @click="fecharDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span class="font-20">Detalhamento</span>

        <v-divider vertical dark class="mx-2"/>

        <div class="font-12">
          <span class="ma-0" v-for="(descricao, key) in ARRAY_DESCRICAO_NIVEIS" :key="key">
            {{ descricao }}
            <v-icon dark small v-if="key !== ARRAY_DESCRICAO_NIVEIS.length - 1">mdi-chevron-right</v-icon>
          </span>
        </div>
      </div>

      <v-card-text class="pb-0 pt-1 px-2">
        <div class="d-flex align-center mb-3">
          <v-icon size="21" class="mr-1">mdi-format-list-bulleted</v-icon>
          <span class="font-17 text-gray-900">Listagem dos produtos</span>

          <v-divider vertical class="mx-3"/>

          <SysBtn class="ml-2" @click="exportarParaExcel">
            <v-icon left>$Excel</v-icon>
            Exportar
          </SysBtn>

          <v-spacer/>

          <div class="w-450">
            <v-text-field
              v-model="pesquisa"
              hide-details
              dense clearable
              label="Pesquisar"
              append-icon="mdi-magnify"
              v-lazy-input:debounce="2000"
              @input="pesquisarProduto"
            />
          </div>
        </div>

        <sys-data-table
          :height="alturaDaJanela - 150"
          item-height="35"
          :headers="cabecalhos"
          :items="produtos"
          content-class="sys-data-table-blue-hover-linha text-black"
          ativar_ordenacao_manual
          @scroll-items="verificarFimScroll"
          @ordernar-coluna-selecionada="ordenarColuna"
        >
          <template #item.descricao_fornecedor="{item}">
            <p v-text="item.descricao_fornecedor" :title="item.descricao_fornecedor" class="text-truncate ma-0"/>
          </template>

          <template #item.descricao_segmento="{item}">
            <p v-text="item.descricao_segmento" :title="item.descricao_segmento" class="text-truncate ma-0"/>
          </template>

          <template #item.descricao_produto="{item}">
            <p v-text="item.descricao_produto" :title="item.descricao_produto" class="text-truncate ma-0"/>
          </template>

          <template #item.markup="{item}">
            {{ `${item.markup}` }}
          </template>

          <template #body.append v-if="produtos.length > produtos_por_pagina">
            <div class="py-4 text-gray-400 font-14">
              <v-icon left>mdi-sort-descending</v-icon>
              FIM DA TABELA
            </div>
          </template>
        </sys-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {buscarDetalhamentoProdutos} from "@/api/Diagnostico/CurvasCruzadas";
import {logout} from "@/helpers";
import ResponsiveHeight from '@/helpers/ResponsiveHeight.js';
import {cabecalhos} from './Cabecalhos.js';
import $axios from "@/api/api";
import {formatarLinhaDetalhamentoProduto} from "./FormatacaoLinha"

export default {
  name: "LinhaDuplamenteClicada",
  mixins: [ResponsiveHeight],
  props: {
    linha: Object
  },
  data: () => ({
    dialog_ativo: false,
    timerScrollDataTable: null,
    todosItensPaginadosCarregados: false,
    pesquisa: '',
    produtos_por_pagina: 200,
    produtos: [],
    cabecalhos,
    order_by: []
  }),
  computed: {
    PAGINA_ATUAL_PRODUTOS() {
      return Math.ceil(this.produtos.length / this.produtos_por_pagina);
    },
    ARRAY_DESCRICAO_NIVEIS() {
      if (!this.linha || !this.linha.descricao_niveis) {
        return [];
      }
      return `${this.linha.descricao_niveis}`.split(/\s-\s/g);
    },
    FILTROS_STORE() {
      return this.$store.getters['filtrosUniversalAvancado/filtros_formatados'];
    }
  },
  watch: {
    linha() {
      this.dialog_ativo = true;
      this.todosItensPaginadosCarregados = false;
      this.buscarDetalhamentosProdutosLinha();
    }
  },
  methods: {
    ordenarColuna(ev) {
      if (ev.value === this.order_by[0] && ev.order === this.order_by[1]) return;

      this.produtos = [];
      this.todosItensPaginadosCarregados = false;

      this.order_by = [ev.value, ev.order];
      this.buscarDetalhamentosProdutosLinha();
    },
    fecharDialog() {
      this.dialog_ativo = false;
      this.todosItensPaginadosCarregados = false;
      this.produtos = [];
    },
    buscarDetalhamentosProdutosLinha() {
      if (!this.dialog_ativo || this.todosItensPaginadosCarregados) {
        return;
      }

      const parametros = {
        ...this.FILTROS_STORE,
        classificacao_popularidade: this.linha.classificacao_popularidade || null,
        classificacao_criticidade: this.linha.classificacao_criticidade || null,
        histogramas: this.linha.histogramas || null,
        segmentos: this.linha.idsegmento
          ? [this.linha.idsegmento]
          : (this.FILTROS_STORE.segmentos || []),
        produto_combinado: (this.linha.idsegmento !== undefined && this.linha.descricao_analise === 'COMBINADOS') ? 'S' : 'N',
        fornecedores: this.linha.idfornecedor
          ? [this.linha.idfornecedor]
          : (this.FILTROS_STORE.fornecedores || []),
        produtos: this.linha.idproduto ? [this.linha.idproduto] : [],
        pagina: (this.PAGINA_ATUAL_PRODUTOS + 1),
        pesquisa: this.pesquisa,
        order_by: this.order_by
      };
      this.$store.dispatch('loading/addRequisicao',
        buscarDetalhamentoProdutos(parametros)
          .then(produtos => {
            this.produtos.push(...produtos.map(formatarLinhaDetalhamentoProduto));

            if (produtos.length < this.produtos_por_pagina) {
              this.todosItensPaginadosCarregados = true;
            }
          })
          .catch(logout)
      );
    },
    pesquisarProduto() {
      if (!(this.pesquisa.length > 0)) return;
      this.produtos = [];
      this.todosItensPaginadosCarregados = false;
      this.buscarDetalhamentosProdutosLinha();
    },
    verificarFimScroll({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 100) < scrollHeight || !(this.produtos.length > 0)) return;
      clearTimeout(this.timerScrollDataTable);
      this.timerScrollDataTable = setTimeout(() => this.buscarDetalhamentosProdutosLinha(), 500)
    },
    exportarParaExcel() {
      const considerar_filtro_fornecedor = this.FILTROS_STORE.fornecedores.map(item => `&fornecedores[]=${item}`).join('') || [];

      const url = 'relatorios/diagnostico/produtos/exportacao-excel'
        + `?grupos[]=${this.FILTROS_STORE.grupos}`
        + `&classificacao_popularidade=${this.linha.classificacao_popularidade || ''}`
        + `&classificacao_criticidade=${this.linha.classificacao_criticidade || ''}`
        + (this.linha.idsegmento ? `&segmentos[]=${this.linha.idsegmento}` : '')
        + (this.linha.idfornecedor ? `&fornecedores[]=${this.linha.idfornecedor}` : considerar_filtro_fornecedor)
        + this.FILTROS_STORE.fornecedores.map(item => `&fornecedores[]=${item}`).join('')
        + (this.linha.idproduto ? `&produtos[]=${this.linha.idproduto}` : '')
        + (this.linha.histograma ? `&histogramas[]=${this.linha.histograma}` : '')
        + `&fora_de_linha=${this.FILTROS_STORE.fora_de_linha || ''}`
        + `&inativo_revenda=${this.FILTROS_STORE.inativo_revenda || ''}`
        + `&produto_resgatado=${this.FILTROS_STORE.produto_resgatado || ''}`
        + `&produto_combinado=${this.linha.idsegmento !== undefined && this.linha.descricao_analise === 'COMBINADOS' ? 'S' : 'N'}`
        + this.FILTROS_STORE.primeira_entrada.map(item => `&primeira_entrada[]=${item}`).join('')
        + this.FILTROS_STORE.ultima_entrada.map(item => `&ultima_entrada[]=${item}`).join('')
        + this.FILTROS_STORE.idade.map(item => `&idade[]=${item}`).join('')
        + '&id_usuario=' + localStorage.id;

      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
    }
  }
}
</script>

<style scoped>
#titulo-dialog {
  height: 55px;
  background: #042333;
  color: white;
  display: flex;
  align-items: center;
}
</style>
